<template>
	<div v-show="show">
		<!-- 没有数据 -->

		<div class="data_none FlexColumn">
			<img :src="urlhead + '/cus0.png'"></img>
			<div class="none_txt">
				暂无更多数据
			</div>
		</div>

		<!--  -->

	</div>
</template>

<script>
	export default {
		name: "nodata",
		components: {

		},
		props: {
			show: {
				type: Boolean,
				defauilt: true,
			},

		},
		data() {
			return {
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
			}
		}
	}
</script>

<style scoped lang="scss">
	.data_none {
		width: 100%;
		min-height: 260px;

		img {
			width: 180px;
			display: block;
		}

		.none_txt {
			color: rgba(166, 166, 166, 1);
			font-size: 14px;
			margin-top: 20px;
		}
	}
</style>
